// Bars: one bar per item (a run of a CI job), height its value, coloured by whether it passed
// (success) or not (danger). An image: give it a label that says what the bars show.
import { cn } from './cn';

export interface Bar {
  value: number;
  ok: boolean;
  /** Shown on hover (a <title>): the run's duration and result. */
  title?: string;
}

export function Bars({
  bars,
  label,
  height = 56,
  className,
}: {
  bars: Bar[];
  label: string;
  height?: number;
  className?: string;
}) {
  const w = 300;
  const gap = 2;
  const n = Math.max(bars.length, 1);
  const bw = Math.max(1, (w - gap * (n - 1)) / n);
  const max = Math.max(...bars.map((b) => b.value), 1);
  return (
    <svg
      className={cn('block w-full', className)}
      height={height}
      viewBox={`0 0 ${w} ${height}`}
      preserveAspectRatio="none"
      role="img"
      aria-label={label}
    >
      {bars.map((b, i) => {
        const bh = Math.max(3, (b.value / max) * (height - 2));
        return (
          <rect
            key={i}
            x={(i * (bw + gap)).toFixed(1)}
            y={(height - bh).toFixed(1)}
            width={bw.toFixed(1)}
            height={bh.toFixed(1)}
            rx="1.5"
            className={b.ok ? 'fill-success opacity-55' : 'fill-danger'}
          >
            {b.title && <title>{b.title}</title>}
          </rect>
        );
      })}
    </svg>
  );
}
